import { I18nContext } from 'contexts/I18n/I18nProvider'
import { RTFSettingsTab } from 'modules/operational/rtf/config/sidebar'
import React, { useContext } from 'react'

type ItemsProps = {
  tab: RTFSettingsTab
  setTab: React.Dispatch<React.SetStateAction<RTFSettingsTab>>
  items: Array<RTFSettingsTab>
}

const i18nItemsMap = {
  [RTFSettingsTab.logProfiles]: 'settings.tab_logs_profile',
  [RTFSettingsTab.logLevels]: 'settings.tab_manage_logs',
  [RTFSettingsTab.flushLogs]: 'settings.tab_flush_logs',
  [RTFSettingsTab.configurationManagement]: 'rtf.configuration_management',
  [RTFSettingsTab.activityLog]: 'all_device_pages.menu_activity_log',
  [RTFSettingsTab.logsHistory]: 'all_device_pages.menu_logs',
}

export default function Items({ items, tab, setTab }: ItemsProps) {
  const t = useContext(I18nContext)

  return (
    <div className='rtf-side-menu-items'>
      {items.map((sidebarItem) =>
        <div
          key={sidebarItem}
          className={`column is-12 is-relative rtf-side-menu-subcategory ${sidebarItem === tab && 'rtf-side-menu-subcategory-active'
            }`}
          onClick={() => setTab(sidebarItem)}
        >
          <span>
            {t(i18nItemsMap[sidebarItem])}
          </span>
        </div>
      )}
    </div>
  )
}
